import { render } from "./401.vue?vue&type=template&id=31b30b8a&scoped=true"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"

import "./401.vue?vue&type=style&index=0&id=31b30b8a&lang=less"
import "./401.vue?vue&type=style&index=1&id=31b30b8a&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/local/v-7pa-xling/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b30b8a"]])

export default __exports__